export const links = [
    
    { name: "My Space", link: "myspace",icon:"fas fa-cloud" },
    { name: "Image Editor", link: "editor", icon:"fas fa-magic" },
    { name: "Profile", link: "profile",icon:"fas fa-address-card" },
  ];

  export const main_links = [
    
    { name: "Home", link: "/home",icon:"fas fa-house"},
    { name: "Contact", link: "/contact",icon:"fas fa-paper-plane"},
    { name: "Pricing", link: "/pricing",icon:"fas fa-money-bill-wave"}
  ];

export const random_login_img = "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=1000&auto=format&fit=crop";
export const profile_banner = "https://images.unsplash.com/photo-1579546929518-9e396f3cc809?q=80&w=2070&auto=format&fit=crop";

export  const profilepic = ()=>{
  return 'https://api.dicebear.com/7.x/avataaars/svg?seed=Felix';
 }

 export const  slides = [
  {
    userName: "John",
    designation: "Manager",
    review: "Great product, highly recommend!",
    img:"https://api.dicebear.com/7.x/avataaars/svg?seed=John"
  },
  {
    userName: "Sarah",
    designation: "Developer",
    review: "This product has improved my productivity.",
    img:"https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah"
  },
  {
    userName: "Michael",
    designation: "Designer",
    review: "The design is sleek and modern.",
    img:"https://api.dicebear.com/7.x/avataaars/svg?seed=Michael"
  },
  {
    userName: "Emily",
    designation: "Marketing Executive",
    review: "Impressive features, worth the investment.",
    img:"https://api.dicebear.com/7.x/avataaars/svg?seed=Emily"
  }
]